module.exports = __webpack_public_path__ + "static/media/image_35.bc3419f5.png";